import React from "react";
import AnimationTimeLine from "../../components/AnimationTimeLinePanel/AnimationTimeLine";
import { useEditorMainPageContext } from "../contexts/EditorMainPageContext";

export const EditorTimelineSection = () => {
  const ctx = useEditorMainPageContext();
  const { openTimeLine } = ctx;

  if (!openTimeLine) return null;

  return (
    <AnimationTimeLine
      tempLayerData={ctx.tempLayer}
      setMultiSelectedComponent={ctx.setMultiSelectedComponent}
      isAspectRatioLocked={ctx.isAspectRatioLocked}
      setContextMenuvisibility={ctx.setContextMenuvisibility}
      contextMenuvisbility={ctx.contextMenuvisbility}
      deleteComponentOnCanvas={ctx.deleteComponentOnCanvas}
      multiSelectedComps={ctx.multiSelectedComps}
      draggerWidth={ctx.draggerWidth}
      setDraggerWidth={ctx.setDraggerWidth}
      showBannertype={ctx.showBannertype}
      layerCompData={ctx.layerCompData}
      setVerticalLineFor={ctx.setVerticalLineFor}
      animationObject={ctx.animationObject}
      setAnimationObject={ctx.setAnimationObject}
      millSeconds={ctx.millSeconds}
      seconds={ctx.seconds}
      setMillSeconds={ctx.setMillSeconds}
      setSeconds={ctx.setSeconds}
      selectedComponent={ctx.selectedComponent}
      setSelectedComponent={ctx.setSelectedComponent}
      setLayerCompData={ctx.setLayerCompData}
      copiedKeyFrame={ctx.copiedKeyFrame}
      setCopiedKeyFrame={ctx.setCopiedKeyFrame}
      popUpOptions={ctx.popUpOptions}
      setPopUpOptions={ctx.setPopUpOptions}
      toggleLockComp={ctx.toggleLockComp}
      toggleHideComp={ctx.toggleHideComp}
      toggleAnimatedBanner={ctx.toggleAnimatedBanner}
      canvasDimension={ctx.canvasDimension}
      setundoFlag={ctx.setundoFlag}
      openTimelinePopup={ctx.openTimelinePopup}
      setOpenTimelinePopup={ctx.setOpenTimelinePopup}
      popUpValuesEdited={ctx.popUpValuesEdited}
      setPopUpValuesEdited={ctx.setPopUpValuesEdited}
      playPause={ctx.playPause}
      setPlayPause={ctx.setPlayPause}
      playPauseRef={ctx.playPauseRef}
      marker={ctx.marker}
      setMarker={ctx.setMarker}
      popUpLeft={ctx.popUpLeft}
      SetPopupLeft={ctx.SetPopupLeft}
      refFroala={ctx.createFroalaInstance?.current}
      clickedTimes={ctx.clickedTimes}
      froalaIndex={ctx.froalaIndex}
      isEditorOn={ctx.isEditorOn}
      setIsEditorOn={ctx.setIsEditorOn}
      bannerChanged={ctx.bannerChanged}
      setBannerChanged={ctx.setBannerChanged}
      layerChangedOnPause={ctx.layerChangedOnPause}
      setLayerChangedOnPause={ctx.setLayerChangedOnPause}
      setMultiSelectedComps={ctx.setMultiSelectedComps}
      setSelectedProperties={ctx.setSelectedProperties}
      selectedProperties={ctx.selectedProperties}
      setSelectedPropertiesIndex={ctx.setSelectedPropertiesIndex}
      selectedPropertiesIndex={ctx.selectedPropertiesIndex}
      setCopyPropertySelected={ctx.setCopyPropertySelected}
      copyPropertySelected={ctx.copyPropertySelected}
      setCopyPasteContextMenuPosition={ctx.setCopyPasteContextMenuPosition}
      copyPasteContextMenuPosition={ctx.copyPasteContextMenuPosition}
      setCopyPasteContextMenuVisibility={ctx.setCopyPasteContextMenuVisibility}
      copyPasteContextMenuVisibility={ctx.copyPasteContextMenuVisibility}
    />
  );
};
